import axios from 'utils/axios';

export const removeDailyConclusionStrategy = (id: number) => {
  return axios.delete(`/api/v1/dailyconclusionstrategies/${id}`);
};
